import { render } from "./Mb024.vue?vue&type=template&id=5e1e32b0&scoped=true"
import script from "./Mb024.vue?vue&type=script&lang=js"
export * from "./Mb024.vue?vue&type=script&lang=js"

import "./Mb024.vue?vue&type=style&index=0&id=5e1e32b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1e32b0"]])

export default __exports__